import {
    postPermiseLoading,
    postPermiseRequest,
    postPermiseSuccess,
    postPermiseReject,
    postPermiseReset
} from "../../actions/profile/postPermise";

export const postPermise = (formData) => async (dispatch, getState) => {
    dispatch(postPermiseLoading());
    try {
        const { data } = await postPermiseRequest(formData, getState);
        dispatch(postPermiseSuccess(data))
    } catch (error) {
        dispatch(postPermiseReject(error))
    } finally {
        setTimeout(() => { dispatch(postPermiseReset()) }, 3000);
    }
    return Promise.resolve();
};